export enum InvestorDetailsTabsEnum {
  SUMMARY = 'Summary',
  COMMITMENTS = 'Commitments',
  ALLOCATIONS = 'Begin Allocation',
  ACTIVITY = 'Activity',
  PACING = 'Pacing',
  DOCUMENTATION = 'Documentation',
  UPDATES = 'Updates'
}

export enum InvestorDetailsEntityTypeEnum {
  Household = 'household',
  Group = 'group',
  GroupedEntity = 'groupedEntity',
  UngroupedEntity = 'ungroupedEntity'
}
